"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captureException = void 0;

var _browserRum = require("@datadog/browser-rum");

var _browser = require("@sentry/browser");

var _config = _interopRequireDefault(require("next/config"));

// Ignored to avoid false positives with auth, non existing end points or wrong user data
var IGNORED_STATUSES = [401, 404, 422];

var isRelevantError = function isRelevantError(exception) {
  var _exception$response;

  var responseStatus = exception === null || exception === void 0 ? void 0 : (_exception$response = exception.response) === null || _exception$response === void 0 ? void 0 : _exception$response.status; // we might get strings or errors that weren't caused by an HTTP request

  if (responseStatus === undefined) {
    return true;
  }

  return !IGNORED_STATUSES.includes(responseStatus);
};

var reportException = function reportException(exception) {
  var _ref = (0, _config["default"])() || {},
      _ref$publicRuntimeCon = _ref.publicRuntimeConfig,
      SENTRY_ENABLED = _ref$publicRuntimeCon.SENTRY_ENABLED,
      DATADOG_RUM_ENABLED = _ref$publicRuntimeCon.DATADOG_RUM_ENABLED;

  if (SENTRY_ENABLED) {
    (0, _browser.captureException)(exception);
  }

  if (DATADOG_RUM_ENABLED) {
    _browserRum.datadogRum === null || _browserRum.datadogRum === void 0 ? void 0 : _browserRum.datadogRum.addError(exception);
  }
};

var captureException = function captureException(exception) {
  if (isRelevantError(exception)) {
    reportException(exception);
  }
};

exports.captureException = captureException;